export const SORT_BY = {
  CLIENT: 'client',
  DATE: 'date',
} as const;

export const SORT_BY_OPTIONS = [
  { label: 'Sort by Client', value: SORT_BY.CLIENT },
  { label: 'Sort by Date', value: SORT_BY.DATE },
];
